(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-search-bar"] && !Shopify.designMode) return;
  try {
    (function() {
  // Icon click -> form show/hide (class based)
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('.js-search-toggle');
    if (!toggle) return;

    var wrapper = toggle.closest('.custom-search-wrapper');
    if (!wrapper) return;

    var form = wrapper.querySelector('.custom-search-bar');
    var input = wrapper.querySelector('.js-predictive-search-input');
    var results = wrapper.querySelector('.js-predictive-search-results');

    if (!form) return;

    var isOpen = form.classList.contains('is-open');
    if (!isOpen) {
      form.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      if (input) input.focus();
    } else {
      form.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (results) {
        results.hidden = true;
        results.innerHTML = '';
      }
    }
  });

  // Predictive search (same as pehle)
  document.addEventListener('input', function(event) {
    var input = event.target.closest('.js-predictive-search-input');
    if (!input) return;

    var wrapper = input.closest('.custom-search-wrapper');
    if (!wrapper) return;

    var form = wrapper.querySelector('.custom-search-bar');
    var results = wrapper.querySelector('.js-predictive-search-results');
    if (!form || !results) return;

    if (!wrapper.__predictiveState) {
      wrapper.__predictiveState = { controller: null };
    }
    var state = wrapper.__predictiveState;

    var query = input.value.trim();

    if (!query.length) {
      results.hidden = true;
      results.innerHTML = '';
      return;
    }

    if (state.controller) state.controller.abort();
    state.controller = new AbortController();

    var params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,page,article',
      'resources[limit]': '4',
      section_id: 'predictive-search'
    });

    fetch('/search/suggest?' + params.toString(), {
      signal: state.controller.signal,
      headers: { 'Accept': 'text/html' }
    })
    .then(function(response) {
      if (!response.ok) return null;
      return response.text();
    })
    .then(function(html) {
      if (!html) return;

      var temp = document.createElement('div');
      temp.innerHTML = html;
      var dropdown = temp.querySelector('#predictive-search-results');

      if (!dropdown) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }

      results.innerHTML = '';
      results.appendChild(dropdown);

      var list = dropdown.querySelector('.predictive-search-results__wrapper-products');
      var items = [];
      if (list) {
        items = list.querySelectorAll('.predictive-search-results__card--product');
      }

      if (items.length > 4) {
        for (var i = 4; i < items.length; i++) {
          items[i].style.display = 'none';
        }
      }

      var existingViewAll = dropdown.querySelector('.predictive-search-view-all');
      if (!existingViewAll) {
        var viewAll = document.createElement('a');
        viewAll.className = 'predictive-search-view-all';
        viewAll.textContent = 'View all results';
        viewAll.href = form.action + '?q=' + encodeURIComponent(query);
        dropdown.appendChild(viewAll);
      } else {
        existingViewAll.href = form.action + '?q=' + encodeURIComponent(query);
      }

      results.hidden = false;
    })
    .catch(function(e) {
      if (e.name === 'AbortError') return;
      console.error(e);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    (function() {
  document.addEventListener('DOMContentLoaded', function() {
    var forms = document.querySelectorAll('.custom-search-bar[data-section-id]');

    forms.forEach(function(form) {
      var input = form.querySelector('.js-predictive-search-input');
      var results = form.querySelector('.js-predictive-search-results');
      var controller;

      if (!input || !results) return;

      input.addEventListener('input', function() {
        var query = input.value.trim();

        if (!query.length) {
          results.hidden = true;
          results.innerHTML = '';
          return;
        }

        if (controller) controller.abort();
        controller = new AbortController();

        var params = new URLSearchParams({
          q: query,
          'resources[type]': 'product,page,article',
          'resources[limit]': '4',
          section_id: 'predictive-search'
        });

        fetch('/search/suggest?' + params.toString(), {
          signal: controller.signal,
          headers: { 'Accept': 'text/html' }
        })
        .then(function(response) {
          if (!response.ok) return null;
          return response.text();
        })
        .then(function(html) {
          if (!html) return;

          // pura HTML temporary div me daalo
          var temp = document.createElement('div');
          temp.innerHTML = html;

          // sirf inner dropdown uthao
          var dropdown = temp.querySelector('#predictive-search-results');

          if (!dropdown) {
            results.hidden = true;
            results.innerHTML = '';
            return;
          }

          // apne container ke andar dropdown dalo
          results.innerHTML = '';
          results.appendChild(dropdown);

          // sirf 4 products dikhane ka logic
          var list = dropdown.querySelector('.predictive-search-results__wrapper-products');
          var items = [];
          if (list) {
            items = list.querySelectorAll('.predictive-search-results__card--product');
          }

          if (items.length > 4) {
            for (var i = 4; i < items.length; i++) {
              items[i].style.display = 'none';
            }
          }

          // dropdown ke andar hi \"View all\" button add/update karo
          var existingViewAll = dropdown.querySelector('.predictive-search-view-all');
          if (!existingViewAll) {
            var viewAll = document.createElement('a');
            viewAll.className = 'predictive-search-view-all';
            viewAll.textContent = 'View all results';
            viewAll.href = form.action + '?q=' + encodeURIComponent(query);
            dropdown.appendChild(viewAll);
          } else {
            existingViewAll.href = form.action + '?q=' + encodeURIComponent(query);
          }

          results.hidden = false;
        })
        .catch(function(e) {
          if (e.name === 'AbortError') return;
          console.error(e);
        });
      });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
